import { useParams } from "react-router-dom";
import { OrderWithId } from "../orders/Order";

function BizDevOrder() {
  const { id } = useParams();
  return <OrderWithId prices id={parseInt(id || "0") || 0} />;
}

export default BizDevOrder;
